'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('../../common/styles');

var fontFamily = _styles.typography.fontStackHeaders.fontFamily;
var color = _styles.colors.baseColors.charcoalGrey;

exports.default = {
	h1: {
		fontFamily: fontFamily,
		fontSize: '24px',
		fontWeight: 400,
		color: color
	},
	h2: {
		fontFamily: fontFamily,
		fontSize: '20px',
		fontWeight: 600,
		color: color
	},
	h3: {
		fontFamily: fontFamily,
		fontSize: '20px',
		fontWeight: 300,
		color: color
	},
	h4: {
		fontFamily: fontFamily,
		fontSize: '16px',
		fontWeight: 400,
		color: color
	}
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMHeading/styles/index.js